import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

export default function AboutThumbnailComponents() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  return (
    <div className="about_content_thumbnail">
      {isMobile ? (
        // Mobile View
        <>
          <div>
            <h2 className="font-vietnam-600 font-size-36 text-uppercase lh-1">
              i really love to technology every day
            </h2>
            <h2 className="font-vietnam-200-italic mt-2">Iqbal Aulia</h2>
          </div>
        </>
      ) : (
        // Desktop View
        <>
          <div className="describe">
            <h1 className="font-vietnam-600">
              i really <br />
              love to <br />
              technology <br />
              every day <br />
            </h1>
            <h2 className="font-vietnam-200-italic">Iqbal Aulia</h2>
          </div>
          <div className="picture">
            <img
              src={require("../../assets/images/profile/profile_1.jpg")}
              alt="about"
              width={"100%"}
              loading="lazy"
            />
          </div>
        </>
      )}
    </div>
  );
}
